import React from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { CheckCircle, ArrowRight } from 'lucide-react'

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('session_id')
  const projectId = searchParams.get('project_id')
  const type = searchParams.get('type')

  const isPackageBooking = type === 'package_booking'
  const isFinal = type === 'final'

  // Titel + boodschap per type
  let title = 'Betaling geslaagd!'
  let lead = ''
  let sub = 'Je ontvangt direct een deelfactuur (1/2) per e-mail. De restbetaling (deelfactuur 2/2) volgt na goedkeuring van de content.'

  if (isPackageBooking) {
    title = 'Boeking bevestigd!'
    lead = 'Je pakket is geboekt. De creator ontvangt een melding en je kunt direct starten met samenwerken in de workspace.'
  } else if (isFinal) {
    title = 'Project afgerond!'
    lead = 'Je eindbetaling (90%) is verwerkt. De content is nu volledig van jou — je vindt alle bestanden terug in de workspace.'
    sub = 'Je ontvangt de tweede deelfactuur (2/2) per e-mail. Bedankt voor je samenwerking!'
  } else {
    // deposit
    title = 'Aanbetaling geslaagd!'
    lead = 'Je aanbetaling (10%) is verwerkt en de workspace is nu geopend. Hier deel je de briefing, chat je met de creator en volg je de voortgang tot oplevering.'
  }

  const showWorkspace = !!projectId && (isPackageBooking || isFinal || (!isPackageBooking && !isFinal))

  return (
    <div className="font-['Inter'] min-h-screen bg-[#FAFAF7] text-[#0A0F0D] flex items-center justify-center">
      <div className="relative bg-white rounded-3xl border border-[#E5E7EB] p-6 sm:p-10 md:p-12 max-w-lg w-full mx-4 my-8 shadow-[0_1px_2px_rgba(0,0,0,0.03),0_24px_50px_-28px_rgba(0,0,0,0.12)]">
        <div className="text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-[#ECFDF5] rounded-2xl flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-[#3EB489]" />
          </div>

          {/* Title */}
          <h1 className="text-2xl sm:text-3xl font-black mb-4">{title}</h1>

          {/* Message */}
          <p className="text-[#0A0F0D] text-base sm:text-lg mb-4">{lead}</p>
          <p className="text-[#64748B] text-sm mb-8">{sub}</p>

          {/* Action Buttons */}
          <div className="space-y-3">
            {showWorkspace ? (
              <>
                <Link
                  to={`/project-workspace/${projectId}`}
                  className="w-full px-6 py-4 bg-[#3EB489] hover:bg-[#359E78] hover:-translate-y-0.5 rounded-xl font-semibold transition-all flex items-center justify-center gap-2 text-white shadow-[0_4px_14px_-3px_rgba(62,180,137,0.5)]"
                >
                  Open workspace
                  <ArrowRight className="w-5 h-5" />
                </Link>
                <Link
                  to="/my-projects"
                  className="w-full px-6 py-4 bg-white border border-[#E5E7EB] hover:border-[#0A0F0D] hover:bg-[#FAFAF7] rounded-xl font-semibold transition text-center block text-[#0A0F0D]"
                >
                  Bekijk mijn opdrachten
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/my-projects"
                  className="w-full px-6 py-4 bg-[#3EB489] hover:bg-[#359E78] hover:-translate-y-0.5 rounded-xl font-semibold transition-all flex items-center justify-center gap-2 text-white shadow-[0_4px_14px_-3px_rgba(62,180,137,0.5)]"
                >
                  Bekijk mijn opdrachten
                  <ArrowRight className="w-5 h-5" />
                </Link>
                <Link
                  to="/projects"
                  className="w-full px-6 py-4 bg-white border border-[#E5E7EB] hover:border-[#0A0F0D] hover:bg-[#FAFAF7] rounded-xl font-semibold transition text-center block text-[#0A0F0D]"
                >
                  Naar marktplaats
                </Link>
              </>
            )}
          </div>

          {/* Session Info */}
          {sessionId && (
            <div className="mt-8 pt-6 border-t border-[#E5E7EB]">
              <p className="text-xs text-[#64748B] break-all">
                Transactie ID: {sessionId.substring(0, 20)}...
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PaymentSuccessPage
